import React, { useContext } from "react";
import estilo from "./styles/Principal.module.css";
import { Route, Routes } from "react-router-dom";

import Inicio from "./pages/Inicio";
import Ingreso from "./pages/Ingreso";
import Registro from "./pages/Registro";
import ChatUsuario from "./pages/ChatUsuario";
import { DataContext } from "./context/DataContext";
import Menu from "./components/Menu";
import Opciones from "./components/Opciones";
import ListaContactos from "./pages/ListaContactos";
import Perfil from "./pages/Perfil";
import ListaUsuarios from "./pages/ListaUsuarios";

function App() {
  const { usuario } = useContext(DataContext);

  return (
    <div className={estilo.principal}>
      {usuario ? <Menu></Menu> : null}

      <Routes>
        <Route path="/" element={usuario ? <Inicio /> : <Ingreso />}></Route>
        <Route
          path="/ingreso"
          element={usuario ? <Inicio /> : <Ingreso />}
        ></Route>
        <Route
          path="/registro"
          element={usuario ? <Inicio /> : <Registro />}
        ></Route>
        <Route
          path="/perfil"
          element={usuario ? <Perfil /> : <Inicio />}
        ></Route>
        <Route
          path="/contactos"
          element={usuario ? <ListaContactos /> : <Inicio />}
        ></Route>
        <Route
          path="/usuarios"
          element={usuario ? <ListaUsuarios /> : <Inicio />}
        ></Route>
        <Route path="/:id" element={<ChatUsuario />}></Route>
      </Routes>

      {usuario ? <Opciones></Opciones> : null}
    </div>
  );
}

export default App;
